<template>
  <div>
    <change-password></change-password>
  </div>
</template>

<script>
import { User } from '@/mixins'

export default {
  name: 'ProfilChangePassword',
  components: {
    ChangePassword: () => import('@/components/users/ChangePassword')
  },
  mixins: [User]
}
</script>
